export function AllAuthorsName(authors) {
    return authors.map((author) => author.name).join(", ")
}